// ============================================================================
// FILE: src/modules/uploads/components/wizard/TemplateStep.js
// MODULE: Generic Upload Framework
//
// PURPOSE:
// Displays template information for the selected upload type and allows
// the user to download the corresponding upload template.
//
// RESPONSIBILITIES:
// - Display selected upload configuration
// - Display template preparation instructions
// - Raise template download callback
//
// NOTES:
// - UI component only.
// - Does not call APIs.
// - UploadDrawer remains responsible for API orchestration.
// ============================================================================
//
// AUTHOR:
// DizyPro ERP Development Team
// ============================================================================

import React from "react";

// ============================================================================
// Component
// ============================================================================

const TemplateStep = ({
    wizard,
    onDownloadTemplate
}) => {

    const uploadType =
        wizard?.uploadTypes?.find(
            item =>
                item.value === wizard.selectedUploadType
        );

    const uploadTypeLabel =
        uploadType?.label ||
        wizard?.selectedUploadType ||
        "-";

    return (

        <div className="upload-step">

            {/* ================================================================
               Step Header
               ================================================================ */}

            <div className="upload-step-header">

                <h4>
                    Upload Template
                </h4>

                <p>
                    Download the template for the selected upload type
                    and prepare the Excel file before uploading it.
                </p>

            </div>

            {/* ================================================================
               Template Information
               ================================================================ */}

            <div className="upload-card">

                <div className="upload-card-header">

                    <h4>
                        Template Information
                    </h4>

                </div>

                <div className="upload-card-body">

                    <div className="upload-configure-step">

                        <div className="form-group">

                            <label>
                                Module
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                value={
                                    wizard?.moduleName ||
                                    wizard?.moduleCode ||
                                    ""
                                }
                                readOnly
                            />

                        </div>

                        <div className="form-group">

                            <label>
                                Entity
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                value={
                                    wizard?.entityName ||
                                    ""
                                }
                                readOnly
                            />

                        </div>

                        <div className="form-group">

                            <label>
                                Upload Type
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                value={uploadTypeLabel}
                                readOnly
                            />

                        </div>

                    </div>

                    {/* ========================================================
                       Download Action
                       ======================================================== */}

                    <div
                        style={{
                            marginTop: "20px",
                            paddingTop: "18px",
                            borderTop: "1px solid #e5e7eb"
                        }}
                    >

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={onDownloadTemplate}
                            disabled={
                                !wizard?.selectedUploadType
                            }
                        >
                            Download Template
                        </button>

                    </div>

                </div>

            </div>

            {/* ================================================================
               Instructions
               ================================================================ */}

            <div className="upload-instructions">

                <h5>
                    Template Instructions
                </h5>

                <ul>

                    <li>
                        Download the template for the selected Upload Type.
                    </li>

                    <li>
                        Do not modify, rename, add, or remove the template
                        column headers.
                    </li>

                    <li>
                        Enter the required master data in the appropriate
                        columns.
                    </li>

                    <li>
                        Do not change the Excel sheet structure provided
                        in the template.
                    </li>

                    <li>
                        Save the completed template as an Excel file before
                        proceeding to the Upload step.
                    </li>

                </ul>

            </div>

        </div>

    );

};

export default TemplateStep;